import { SingleTierTax } from './../../classes/singleTierTax/singleTierTax';
import { TierRate } from '../../interfaces';
import { CombinatieKortingConfig } from './interface';
import { rates } from './config';

export class CombinatieKorting {
    
    tax: number;
    
    constructor(data: CombinatieKortingConfig) {
        const property = data.senior ? 'senior' : 'nonSenior';
        const ratesForYear: TierRate[] = rates[property][data.year];

        this.tax = new SingleTierTax(ratesForYear, data.income).tax;
    }
    
}
